import { templates as templateService } from '@chilipiper/service'
import { Template } from '@chilipiper/api-type-def'

export const templatesByWorkspace = (workspaceId: string) => {
  return templateService.byWorkspace(workspaceId)
}

export const findDefaultTemplate = async () => {
  const templates = await templateService.getOwn()

  return templates.find(t => t.default)
}

export const getTemplateById = (templateId: string) => {
  return templateService.byId(templateId)
}

export const saveTemplate = (template: Template) => {
  return templateService.save(template)
}

export const isTemplateModified = (template: Template) => {
  return template.updatedAt != null
}
